import type { IExtractRouteParamMap } from "@/routes/types";
import { createPaths } from "@/routes/utils";

const baseRoute = `/settings`;

export const settingsRoutesObj = {
  home: baseRoute,
} as const;

export type ISettingsRouteParams = IExtractRouteParamMap<
  typeof settingsRoutesObj
>;

export const settingsPath = createPaths<
  typeof settingsRoutesObj,
  ISettingsRouteParams
>(settingsRoutesObj);
